<content *ngIf="dataGrid">
    <table>
        <thead>
            <tr>
                <th class="string" *ngIf="showCampanya">{{'centralEstadisticas.grid.campanya' | translate}}</th>
                <th class="string" *ngIf="showPais">{{'global.pais' | translate}}</th>
                <th class="string" *ngIf="showDenominacion">{{'centralEstadisticas.grid.denominacion' | translate}}</th>
                <th class="string" *ngIf="showCultivosNumber">{{'centralEstadisticas.grid.numCultivos' | translate}}</th>
                <th class="string" *ngIf="showCultivosPercentage">{{'centralEstadisticas.grid.porcentajeCultivos' | translate}}</th>
                <th class="string" *ngIf="showAforoNumber">{{'centralEstadisticas.grid.aforo' | translate}}</th>
                <th class="string" *ngIf="showAforoPercentage">{{'centralEstadisticas.grid.porcentajeAforo' | translate}}</th>
                <th class="string" *ngIf="showSuperficieNumber">{{'centralEstadisticas.grid.superficie' | translate}}</th>
                <th class="string" *ngIf="showSuperficiePercentage">{{'centralEstadisticas.grid.porcentajeSuperficie' | translate}}</th>
            </tr>
        </thead>
        <tbody *ngFor="let row of dataGrid; let i = index">
            <tr *ngIf="i < lastItemList && i >= firstItemList">
                <td class="string" *ngIf="showCampanya">{{row.anyo}}</td>
                <td class="string" *ngIf="showPais">{{row.desPais}}</td>
                <td class="string" *ngIf="showDenominacion">{{row.desDenominacion}}</td>
                <td class="string" *ngIf="showCultivosNumber">{{row.numCultivos}}</td>
                <td class="string" *ngIf="showCultivosPercentage">{{row.porcentajeCultivos}}</td>
                <td class="string" *ngIf="showAforoNumber">{{row.sumAforos | number : '1.0-0' : defaultLanguage}}</td>
                <td class="string" *ngIf="showAforoPercentage">{{row.porcentajeAforo}}</td>
                <td class="string" *ngIf="showSuperficieNumber">{{row.sumSuperficies | number : '1.0-3' : defaultLanguage}}</td>
                <td class="string" *ngIf="showSuperficiePercentage">{{row.porcentajeSuperficie}}</td>
            </tr>
        </tbody>
        <tfoot *ngIf="!dataGrid || (dataGrid && dataGrid.length < 1)">
            <tr>
                <td colspan="4">
                    {{'global.noContent' | translate}}
                </td>
            </tr>
        </tfoot>
    </table>
    <app-paginator
        *ngIf="(dataGrid && dataGrid.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
</content>
<footer *ngIf="dataGrid" class="button-bar-right">
    <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>